import React, { type FC, type ReactElement } from 'react'
import { Navigate } from 'react-router'
import { useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'

interface AuthorizedProps {
  props: {
    requireIsAuthenticated: boolean
    requireIsAssignedToCompany: boolean
    requireIsAdmin: boolean
  }

  child: ReactElement
}

export const Authorized: FC<AuthorizedProps> = (props) => {
  const { child } = props
  const requirements = props.props
  const {
    isAuthenticated,
    isAssignedToCompany,
    isAdmin
  } = useAppSelector((state: RootState) => state.auth)

  if (requirements.requireIsAuthenticated && !isAuthenticated) return <Navigate to='/login'/>
  if (requirements.requireIsAssignedToCompany && !isAssignedToCompany) return <Navigate to='/landing'/>
  if (requirements.requireIsAdmin && !isAdmin) return <Navigate to='/login'/>
  return child
}
